import React from 'react';
import styled from 'styled-components';
import { TextWithLine } from '../Text';
import {
  Container as SellerProfileContainer,
  Text as SellerProfileText,
} from './SellerProfile';

const Container = styled(SellerProfileContainer)`
  padding-left: 2rem;
  @media only screen and (max-width: 1100px) {
    border: 1px solid #e5e8f0;
    box-shadow: 0 0;
  }
  @media only screen and (max-width: 1000px) {
    max-width: 100%;
  }
`;

const Text = styled(SellerProfileText)`
  margin-left: 0;
`;

const InfoContainer = styled.div`
  & > * {
    margin-bottom: 1rem;
  }
`;

type BuyerProfileProps = {
  purchases: number;
  noFeePurchases: number;
};

export const BuyerProfile = (props: BuyerProfileProps) => (
  <Container>
    <Text className="mt-4 mb-2">Buyer Profile</Text>
    <InfoContainer>
      <TextWithLine title={String(props.purchases)} subtitle="Rentals" />
      <TextWithLine
        title={String(props.noFeePurchases)}
        subtitle="No-fee transactions"
      />
      <TextWithLine title="10%" subtitle="Transaction fee" />
    </InfoContainer>
  </Container>
);
